export const FETCH_LIST_USER_MANAGEMENT_API_SUCCESS =
  "userManagemnent/FETCH_LIST_USER_MANAGEMENT_API_SUCCESS";
export const FETCH_USER_INFO_MANAGEMENT_API_SUCCESS =
  "userManagemnent/FETCH_USER_INFO_MANAGEMENT_API_SUCCESS";
